<template>
  <slot-closure-dialog-shell
    :value="value"
    :title="`編輯 ${formatClosureDate(closure.date)}`"
    :dirty="dirty"
    :saving="saving"
    @input="$emit('input', $event)"
  >
    <slot-closure-doctor-table
      :doctors="doctors"
      :columns="columns"
      max-height="calc(90vh - 230px)"
      @toggle-all="toggleAll"
      @toggle-doctor="toggleDoctor"
    />

    <div v-if="!checked.length" class="closure-warning" role="alert">
      <v-icon small color="#8A4B00">mdi-alert</v-icon>
      沒有勾選醫師，儲存後這天會重新開放
    </div>

    <template #submit>
      <v-btn color="primary" :disabled="!dirty" :loading="saving" @click="submit">儲存</v-btn>
    </template>
  </slot-closure-dialog-shell>
</template>

<script>
import SlotClosureDialogShell from "./SlotClosureDialogShell.vue";
import SlotClosureDoctorTable from "./SlotClosureDoctorTable.vue";
import {
  buildExcludedCodes,
  formatClosureDate,
  selectableCodes,
  toggleAllCodes
} from "@/utils/slotClosure";

export default {
  name: "SlotClosureEditDialog",

  components: {SlotClosureDialogShell, SlotClosureDoctorTable},

  props: {
    value: {
      type: Boolean,
      required: true
    },
    closure: {
      type: Object,
      required: true
    },
    doctors: {
      type: Array,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const checked = selectableCodes(this.doctors)
      .filter(code => !this.closure.excluded_doctor_codes.includes(code))
    return {
      checked,
      originalChecked: [...checked],
      formatClosureDate
    }
  },

  computed: {
    columns() {
      return [{
        key: this.closure.date,
        label: formatClosureDate(this.closure.date),
        checkedCodes: this.checked
      }]
    },
    dirty() {
      return this.checked.length !== this.originalChecked.length
        || this.checked.some(code => !this.originalChecked.includes(code))
    }
  },

  methods: {
    toggleDoctor(date, code) {
      this.checked = this.checked.includes(code)
        ? this.checked.filter(selected => selected !== code)
        : [...this.checked, code]
    },
    toggleAll() {
      this.checked = toggleAllCodes(this.doctors, this.checked)
    },
    submit() {
      this.$emit('submit', {
        date: this.closure.date,
        excluded_doctor_codes: buildExcludedCodes(this.doctors, this.checked, this.closure.excluded_doctor_codes)
      })
    }
  }
}
</script>

<style scoped>
.closure-warning {
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 4px;
  background: #fff4e0;
  color: #8a4b00;
}
</style>
